var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autobookpro-page-content"},[_c('div',{staticClass:"q-mt-md q-mx-auto",staticStyle:{"max-width":"600px"}},[_c('app-ring-central-integration-card',{attrs:{"isPrimary":true}}),_c('app-ring-central-integration-card',{attrs:{"isPrimary":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }